<template>
  <div>


        <div class="hidden sm:block">
          <header class="header-selected header_top">
            <button class="header-logo" aria-label="homepage">
              <img class="object-cover w-auto h-20" src="../assets/vqvtest.png">
            </button>
            <nav class="main-nav">
              <ul class="nav__list">
                <li @click="scrollHome" class="nav__list-item"><button class="nav__link">Home</button></li>
                <li class="nav__list-item">
                  <button @click="scrollProyect" class="nav__link">Web Apps</button>
                </li>
                <li class="nav__list-item">
                  <button @click="scrollServices" class="nav__link">Services</button>
                </li>
                <li @click="scrollAbout" class="nav__list-item"><button class="nav__link">About Us</button></li>
              </ul>
            </nav>
          </header>
        </div>



        <div class="top-hero">
           
              <div id="section-home" class="home-intro sm:py-24 relative overflow-hidden">
                <div aria-hidden="true" class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
                  <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
                    <path class="text-blue-800 text-opacity-20" fill="currentColor" d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
                    <path class="text-blue-900 text-opacity-40" fill="currentColor" d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
                  </svg>
                </div>
                <div class="absolute inset-0 " id="particles-js"></div>
                <div class="relative">
                
                    <!-- logo-vqv  -->
                  <img class="animate-logo object-cover h-full w-full opacity-25 block sm:hidden" src="../assets/vqvtest.png">

                    <div class="relative overflow-hidden -mt-24 sm:-mt-0">
                      <div class="p-8 mb-4 mx-auto max-w-7xl px-4 sm:mt-8 sm:px-6">

                          <div class="text-center">

                            <span class="text-3xl sm:text-6xl tracking-tight font-extrabold text-white rounded-full px-2 py-1 uppercase">
                            vision quest venture
                            </span> 

                            <h1 style="-webkit-background-clip: text;" class="gradientCss text-4xl tracking-tight font-extrabold sm:text-5xl">
                              <span class="typeText text-3xl sm:text-6xl">Custom </span>
                            </h1>

                            <div class="relative mt-1">
                              <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                <div class="w-full border-t border-gray-700"></div>
                              </div>
                              <div class="relative flex justify-center">
                                <span class="px-2 bg-gradient-to-r from-orange-500 to-orange-800 text-sm rounded-md text-white font-bold"> Business Technology </span>
                              </div>
                            </div>

                            <!-- <h1 style="-webkit-background-clip: text;" class="mt-2 text-gray-100 text-4xl tracking-tight font-extrabold">
                              Business Technology
                            </h1> -->
                            <p class="font-sans mt-4 max-w-md mx-auto text-base text-gray-300 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                              By building custom software, we are able to provide exactly what is needed, in a way that works for you!<br>
                              CUSTOM BUILT software integrates with Web and Mobile Applications giving your business a competitive advantage!<br>
                              Contact us for a consultation and start dominating your market!
                            </p>
                            <img class="h-72 text-center mx-auto transform transition duration-500 hover:scale-110" src="../assets/world.png"> 
                          </div>

                        </div>

                    </div>

                </div>
              </div>

 
        </div>


        <div class="relative bg-gradient-to-r from-gray-100 via-gray-300 to-gray-50">
          <div class="max-w-7xl mx-auto py-8 px-4">
            <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div class="slide-in from-left">
                <h2 class="slide-in parent-div text-3xl font-extrabold sm:text-4xl">
                  Software Development, Deployment and Hosting
                </h2>
                <p class="mt-3 max-w-3xl text-base sm:text-lg text-gray-500">
                  VQV has software available for multiple industries that provide a quickstart foundation to build your business on.<br><br>
                  All software by VQV is fully customizable: Scale as your business grows, analytics dashboard based on your specifications.<br><br>
                  Expand into the App world with web or native Applications using our powerful API's.
                </p>
            
                <button @click="showContactModal" class="flex items-center justify-center px-2.5 py-1 sm:px-4 sm:py-2 text-sm font-base rounded-md text-white bg-gradient-to-r from-blue-800 to-blue-600">
                  Contact Us
                </button>
              
              </div>
              <div class="slide-in from-right my-4 sm:my-0 grid grid-cols-2 gap-4 md:grid-cols-3 lg:mt-0 lg:grid-cols-2 shadow-xl">
                <div class="col-span-1 flex justify-center rounded py-2 px-2 bg-gray-100">
                  <!-- <img class="object-cover p-8 opacity-25" src="../../public/logos/city-hall.png" alt="cityHall"> -->
                  <img class="object-cover hover:opacity-75" src="https://homemanagerfortesting.s3.amazonaws.com/chamber.png" alt="cityHall">
                </div>
                <div class="col-span-1 flex justify-center py-2 px-2 bg-gray-100">
                  <img class="object-cover hover:opacity-75" src="https://homemanagerfortesting.s3.amazonaws.com/360demo.jpg" alt="contract">
                </div>
                <div class="col-span-1 flex justify-center py-2 px-2 bg-gray-100">
                  <img class="object-cover hover:opacity-75" src="https://homemanagerfortesting.s3.amazonaws.com/glen.jpg" alt="helmet">
                </div>
                <div class="col-span-1 flex justify-center py-2 px-2 bg-gray-100">
                  <img class="object-cover hover:opacity-75" src="https://homemanagerfortesting.s3.amazonaws.com/twon.jpg" alt="phone">
                </div>

              </div>
            </div>
            <div id="section-proyect"></div>
          </div>

        </div>

        <div class="top-hero">
            <products-index></products-index>
  
            <div id="section-services">

              <div class="relative overflow-hidden">
                <div class="bg-black bg-opacity-20 py-16 sm:py-24 lg:py-32">
                  <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">

                    <p class="mt-2 text-3xl font-extrabold text-gray-50 sm:text-4xl">
                      <span class="uppercase text-3xl sm:text-5xl"> Software and Apps</span>
                    </p>

                    <div class="relative mt-1">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                            <div class="w-full border-t border-gray-700"></div>
                        </div>
                        <div @click="showContactModal"  class="relative flex justify-center cursor-pointer">
                            <span class="px-2 bg-gradient-to-r from-orange-500 to-orange-800 text-sm rounded-md text-white font-bold"> Contact Us </span>
                        </div>
                    </div>

                    <p class="font-sans mt-4 max-w-md mx-auto text-base text-gray-300 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                      VQV's full stack developers provide a one stop shop to create your business software solutions. Contact us for a consultation and start dominating your market!
                    </p>

                    <div class="mt-12">
                      <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/cloud-upload -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Consultations</h3>
                              <p class="mt-5 text-base text-gray-400">
                                Determine the best method of approach, create a plan, determine measures of effectiveness, establish timelines for development.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/lock-closed -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Web Applications</h3>
                              <p class="mt-5 text-base text-gray-400">
                                Access the power of an App on a browser, providing effortless / global access to clients.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/refresh -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Cloud Storage</h3>
                              <p class="mt-5 text-base text-gray-400">
                                Save costs by storing data in the Cloud! Secure daily data backups, files and multimedia.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/shield-check -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Powerful API's</h3>
                              <p class="mt-5 text-base text-gray-400">
                                API's help businesses expand in a natural way and stitch the internet and mobile app economy together.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/cog -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Front and Back End Development</h3>
                              <p class="mt-5 text-base text-gray-400">
                                Front end development for highly functional UI's<br>Back end development for automated functions, data analysis, database design and creation.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="pt-6">
                          <div class="flow-root rounded-md bg-black bg-opacity-25 zoomIn p-2">
                            <div class="-mt-6">
                              <div>
                                <span class="inline-flex items-center justify-center p-3 bg-gradient-to-r from-orange-500 to-orange-800 rounded-md shadow-lg">
                                  <!-- Heroicon name: outline/server -->
                                  <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
                                  </svg>
                                </span>
                              </div>
                              <h3 class="mt-8 text-lg font-medium text-gray-100 tracking-tight">Hosting and Customer Support</h3>
                              <p class="mt-5 text-base text-gray-400">
                                All software is warrantied and can be fully hosted or transferred to your preferred hosting source.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
       </div>

        <div id="section-about" class="relative bg-gradient-to-r from-gray-100 via-gray-300 to-gray-50">
          <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">

              <div class="slide-in from-left">
                <team></team>
              </div>

          </div>

        </div>



        <footer-page></footer-page>


        <!-- modal -->
        <v-dialog v-model="displayModal" v-if="displayModal" width="900">

            <div class="bg-gray-900 bg-opacity-25 py-4 rounded-md px-4 ">
                <getStarted></getStarted>
            </div>

        </v-dialog>


        <!-- responsive menu -->
        <div class="w-full bg-gradient-to-r from-black to-gray-900 py-2 px-2 text-center fixed  sm:hidden bottom-0 z-20">
  
            <div class="flex flex-row text-center">
              <div class="ml-2 mr-3 flex-1">
                  <a @click="scrollHome" class="block py-1 pl-1  text-white no-underline border-b-2 border-gray-500">
                  <i class="fas fa-home text-indigo-600"></i><span class="pb-1 text-xs text-white block">Home</span>
                  </a>
              </div>
              <div class="mr-3 flex-1">
                  <a @click="scrollProyect" class="block py-1 pl-1  text-white no-underline border-b-2 border-gray-500">
                  <i class="fas fa-users text-indigo-600"></i><span class="pb-1 text-xs text-white block">Web Apps</span>
                  </a>
              </div>
              <div class="mr-3 flex-1">
                  <a @click="scrollServices" class="block py-1 pl-1  text-white no-underline border-b-2 border-gray-500">
                  <i class="fas fa-link text-indigo-600"></i><span class="pb-1 text-xs text-white block">Services</span>
                  </a>
              </div>
              <div class="mr-3 flex-1">
                  <a @click="scrollAbout" class="block py-1 pl-1 text-white no-underline border-b-2 border-gray-500">
                  <i class="far fa-address-book text-indigo-600"></i><span class="pb-1 text-xs text-white block">About Us</span>
                  </a>
              </div>

            </div>
       
        </div>



  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import GetStarted from '../components/publicViews/GetStarted.vue';

export default {
  components: { GetStarted },


  data() {
    return {
      valueHidden: "",
      displayModal: false,
    };
  },

  mounted() {
    this.checkFades;
    this.displayMenu;
    this.changeText;
    this.checkAnimate;
    this.initParticles();
  },

  computed: {

    checkAnimate() {
      const animateLogo = document.querySelector(".animate-logo");
      return console.log(animateLogo);
    },

    checkFades(){

      const sliders = document.querySelectorAll(".slide-in");
      const appearOptions = {
         threshold: 0,
         //rootMargin: "-100px 0px 0px 0px"
      };

      const appearOnScroll = new IntersectionObserver(function(entries,appearOnScroll)
        {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              return
            } else {
              entry.target.classList.add("appear");
              appearOnScroll.unobserve(entry.target);
            }
        });
      },
      appearOptions);

      return sliders.forEach(slider => {
       return appearOnScroll.observe(slider);
      });
    },

    displayMenu(){
      const header = document.querySelector('.header-selected');
      // const logoImg = document.querySelector('.header-logo');
      const sectionOne = document.querySelector('.home-intro');
      const sectionOneOption = {
        rootMargin: "-50px 0px 0px 0px"
      };
      const sectionOneObserver = new IntersectionObserver(function (entries) {
        entries.forEach( entry => {
          if(!entry.isIntersecting){
            header.classList.add('nav-scrolled');
            // logoImg.classList.remove('site-logo');
            // logoImg.classList.add('site-logo-show');

          }else {
            header.classList.remove('nav-scrolled');
            // logoImg.classList.add('site-logo');
            // logoImg.classList.remove('site-logo-show');
          }
        })
      }, sectionOneOption);

     return sectionOneObserver.observe(sectionOne);

    },


    changeText() {

      var typeText = document.querySelector(".typeText")
      //var textToBeTyped = "Custom"
      var textToBeTypedArr = ["Customized", "Personalized"]
      var index = 0, isAdding = true, textToBeTypedIndex = 0

      function playAnim() {
        setTimeout(function () {
          // set the text of typeText to a substring of the text to be typed using index.
          typeText.innerText = textToBeTypedArr[textToBeTypedIndex].slice(0, index)
          if (isAdding) {
            // adding text
            if (index > textToBeTypedArr[textToBeTypedIndex].length) {
              // no more text to add
              isAdding = false
              //break: wait 2s before playing again
              setTimeout(function () {
                playAnim()
              }, 2000)
              return
            } else {
              // increment index by 1
              index++
            }
          } else {
            // removing text
            if (index === 0) {
              // no more text to remove
              isAdding = true
              //switch to next text in text array
              textToBeTypedIndex = (textToBeTypedIndex + 1) % textToBeTypedArr.length
            } else {
              // decrement index by 1
              index--
            }
          }
          // call itself
          playAnim()
        }, isAdding ? 120 : 60)
      }
      // start animation
      return playAnim()

    }
  

  },


  methods: {

    goAccount() {
       this.$router.push({ name: "myProfile" },);
    },

    initParticles() {
      if ($('#particles-js').length) {
        particlesJS("particles-js", {
          "particles": {
            "number": {
              "value": 50,
              "density": {
                "enable": true,
                "value_area": 1000
              }
            },
            "color": {
              "value": ["#5507fc"]
            },
            "shape": {
              "type": "circle",
              "stroke": {
                "width": 3,
                "color": "#5507fc"
              },
              "polygon": {
                "nb_sides": 5
              },
              "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
              }
            },
            "opacity": {
              "value": 0.6,
              "random": false,
              "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
              }
            },
            "size": {
              "value": 2,
              "random": true,
              "anim": {
                "enable": false,
                "speed": 40,
                "size_min": 0.1,
                "sync": false
              }
            },
            "line_linked": {
              "enable": true,
              "distance": 120,
              "color": "#5507fc",
              "opacity": 0.2,
              "width": 1.6
            },
            "move": {
              "enable": true,
              "speed": 1,
              "direction": "top",
              "random": false,
              "straight": false,
              "out_mode": "out",
              "bounce": false,
              "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
              }
            }
          },
          "interactivity": {
            "detect_on": "canvas",
            "events": {
              "onhover": {
                "enable": true,
                "mode": "grab"
              },
              "onclick": {
                "enable": false
              },
              "resize": true
            },
            "modes": {
              "grab": {
                "distance": 140,
                "line_linked": {
                  "opacity": 1
                }
              },
              "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
              },
              "repulse": {
                "distance": 200,
                "duration": 0.4
              },
              "push": {
                "particles_nb": 4
              },
              "remove": {
                "particles_nb": 2
              }
            }
          },
          "retina_detect": true
        });
      }
    },


    scrollServices() {
      const element = document.getElementById('section-services');
      element.scrollIntoView({ behavior: 'smooth' });
    },

   scrollProyect() {
      const element = document.getElementById('section-proyect');
      element.scrollIntoView({ behavior: 'smooth' });
    },

    scrollAbout() {
      const element = document.getElementById('section-about');
      element.scrollIntoView({ behavior: 'smooth' });
    },

   scrollHome(){
      const element = document.getElementById('section-home');
      element.scrollIntoView({ behavior: 'smooth' });
    },

    showContactModal(){
        this.displayModal = true;
    }

  }
};
</script>
<style lang="scss">

$color-antiwhite: #edf2f4;
$color-gunmetal: #060318;

.top-hero {
  overflow: auto;
  background-color: #000;
  background-image: linear-gradient(
      rgba($color-gunmetal, 0.7),
      rgba($color-gunmetal, 0.7)
    ),
    url("../assets/dblue.jpg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;

}


.gradientCss {
  background: -webkit-linear-gradient(rgb(255, 255, 255), rgb(216, 216, 216));
  -webkit-text-fill-color: transparent;
}

.parent-div {
  transition: color 1000ms ease-in, opacity 250ms ease-in;
  color: #000;
  opacity: 0;
}

.from-left {
  transform: translateX(-50%);
}

.from-right {
  transform: translateX(50%);
}

.from-left,
.from-right {
  transition: opacity 400ms ease-in, transform 800ms ease-in;
  opacity: 0;
}

.from-left.appear,
.from-right.appear {
  transform: translateX(0);
  opacity: 1;
}

.parent-div.appear {
  color: rgb(10, 12, 92);
  opacity: 1;
  text-shadow: 5px 5px 5px rgb(214, 214, 214);
}

// .logo-vqv {
//   display: block;
//   transform: translateX(-50%);
//   transition: opacity 250ms ease-in, transform 400ms ease-in, display 250ms ease-in ;
//   opacity: 0;
// }
// .logo-vqv.appear {
//   transform: translateX(0);
//   opacity: 1;
// }

// .logo-vqv.disappear {
//   display: none;
//   transform: translateX(0);
//   opacity: 1;
// }

.site-logo {
  visibility: hidden;
}

.site-logo-show {
  visibility: visible;
  filter: invert(100%);
}

.header_top {
  --text: #f4f4f4;
  --text-inverse: #333;
  --background: linear-gradient(59deg, rgba(255,255,255,0) 0%, rgba(0,2,28,0.6979166666666667) 58%, rgba(0,0,0,0.835171568627451) 100%);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 3em;
  transition: background 250ms ease-in;
  background: var(--background);
  color: var(--text);
}

.nav__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.nav__link {
  --spacing: 1em;
  text-decoration: none;
  color: inherit;
  display: inline-block;
  padding: calc(var(--spacing) / 2) var(--spacing);
  position: relative;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.9rem;
}

.nav__link:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: var(--spacing);
  right: var(--spacing);
  height: 2px;
  background: currentColor;
  -webkit-transform: scaleX(0);
          transform: scaleX(0);
  transition: -webkit-transform 150ms ease-in-out;
  transition: transform 150ms ease-in-out;
  transition: transform 150ms ease-in-out, -webkit-transform 150ms ease-in-out;
}

.nav__link:hover::after {
  -webkit-transform: scaleX(1);
          transform: scaleX(1);
}

.nav-scrolled {
  --text: #333;
  --text-inverse: #f4f4f4;
  --background: linear-gradient(59deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.9) 100%);
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.2);
}


.typeText::after {
  content: "|";
  animation:  blink 1s step-end infinite;
}

@keyframes blink {
  0%, 100% {opacity: 1;}
  50% {opacity: 0;}
}

.zoomIn  {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}

.zoomIn:hover  {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}


</style>
